import { prisma, Prisma } from "client";

export const updateDefault = async (
  data: Prisma.DefaultCreateInput,
  eventId: string
) => {
  return await prisma.default.upsert({
    where: { eventId },
    update: data,
    create: {
      ...data,
      event: {
        connect: {
          id: eventId,
        },
      },
    },
  });
};
